// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_NEXT_PHOTO = "P\u0159idej fotku";
